import { WifiStrengthLockOutlineIcon } from './WifiStrengthLockOutlineIcon';

/**
 * author: Simran
 * id 718740BB-FC95-47E4-856B-0A469966C8DD
 * name wifi-strength-lock-outline
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wifi-strength-lock-outline.svg
 * tags
 * - Lock 
 */
export const WifiStrength0LockIcon = WifiStrengthLockOutlineIcon;
export default WifiStrength0LockIcon